/**
 * Deployment and environment check utilities
 */

export const checkDeploymentEnvironment = () => {
  const deploymentInfo = {
    timestamp: new Date().toISOString(),
    buildId: import.meta.env.VITE_BUILD_ID || 'unknown',
    environment: import.meta.env.MODE,
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL ? 'configured' : 'missing',
    supabaseKey: import.meta.env.VITE_SUPABASE_ANON_KEY ? 'configured' : 'missing',
    razorpayKey: import.meta.env.VITE_RAZORPAY_KEY_ID ? 'configured' : 'missing',
  };

  console.log('🚀 Deployment Environment Check:', deploymentInfo);
  
  // Add deployment info to window for debugging
  if (typeof window !== 'undefined') {
    (window as any).__DEPLOYMENT_INFO__ = deploymentInfo;
  }

  return deploymentInfo;
};

export const checkForServiceWorkers = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      if (registrations.length > 0) {
        console.warn('⚠️ Service Workers detected:', registrations.length);
        console.log('Service Workers:', registrations);
        
        // Optionally unregister all service workers to prevent caching issues
        registrations.forEach(registration => {
          console.log('Unregistering service worker:', registration.scope);
          registration.unregister();
        });
      } else {
        console.log('✅ No service workers found');
      }
    });
  }
};

export const clearAllCaches = async () => {
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      if (cacheNames.length > 0) {
        console.warn('⚠️ Browser caches detected:', cacheNames);
        
        // Clear all caches
        await Promise.all(
          cacheNames.map(cacheName => {
            console.log('Clearing cache:', cacheName);
            return caches.delete(cacheName);
          })
        );
        
        console.log('✅ All browser caches cleared');
      } else {
        console.log('✅ No browser caches found');
      }
    } catch (error) {
      console.error('Error clearing caches:', error);
    }
  }
};

export const forceReload = () => {
  // Force a hard reload to bypass any remaining cache
  if (typeof window !== 'undefined') {
    window.location.reload();
  }
};